import { Component, Input } from '@angular/core';

import { VideogularComponent } from './videogular/Videogular.Component';
import { VgStates } from './videogular/VgStates';

@Component({
	selector: 'vb-subtitle-display',
	template: `
		@if (vgApi.isHtmlSubtitleRenderingEnabled && vgApi.currentSubtitle && isPlaying) {
			<div
				class="subtitles"
				[innerHTML]="vgApi.currentSubtitle">
			</div>
		}
	`,
	standalone: false,
	styleUrls: ['./VbSubtitleDisplay.Component.ng.less']
})
export class VbSubtitleDisplayComponent {
	constructor(
		public vgApi: VideogularComponent
	) {}

	public get isPlaying(): boolean {
		return this.vgApi.currentState === VgStates.PLAY;
	}
}
